import { render, staticRenderFns } from "./Cpagina.vue?vue&type=template&id=0d6a1a2e&"
import script from "./Cpagina.vue?vue&type=script&lang=js&"
export * from "./Cpagina.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports